import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  OfferOverviewModel,
  OverviewState,
  RequestsOverviewModel,
} from '../../models/overview.model';

export const selectOffer = createFeatureSelector<OverviewState>('offerModule');
export const selectRequest = createFeatureSelector<OverviewState>('offerModule');

export const selectOfferList = createSelector(
  selectOffer,
  (state: OverviewState) =>
    state.offerOverviewList?.map<OfferOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
      customerName: overviewModel.customer?.name,
      shipToAddress: `${overviewModel.shipTo?.street} ${
        overviewModel.shipTo?.houseNumber ? overviewModel.shipTo?.houseNumber : ''
      }, ${overviewModel.shipTo?.postalCode} ${overviewModel.shipTo?.city}`,
      contactInformation: `${overviewModel.customer?.emailAddress} / ${overviewModel.customer?.phoneNumber}`,
    })) ?? [],
);

export const selectRequestsList = createSelector(
  selectRequest,
  (state: OverviewState) =>
    state.requestsOverviewList?.map<RequestsOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
      customerName: overviewModel.customer?.name,
      shipToAddress: `${overviewModel.shipTo?.street} ${
        overviewModel.shipTo?.houseNumber ? overviewModel.shipTo?.houseNumber : ''
      }, ${overviewModel.shipTo?.postalCode} ${overviewModel.shipTo?.city}`,
      contactInformation: `${overviewModel.customer?.emailAddress} / ${overviewModel.customer?.phoneNumber}`,
    })) ?? [],
);

export const selectOfferPaginationOptions = createSelector(
  selectOffer,
  (state: OverviewState) => state.offerPageAndSize,
);

export const selectOverviewOfferLoading = createSelector(
  selectOffer,
  (state: OverviewState) => state.overviewOffersLoading,
);

export const selectOverviewRequestsLoading = createSelector(
  selectOffer,
  (state: OverviewState) => state.overviewRequestsLoading,
);

export const selectRequestPaginationOptions = createSelector(
  selectRequest,
  (state: OverviewState) => state.requestsPageAndSize,
);

export const getTotalNumberOfOffers = createSelector(
  selectOffer,
  (state: OverviewState) => state.totalNumberOfOffers,
);
export const getTotalNumberOfRequests = createSelector(
  selectOffer,
  (state: OverviewState) => state.totalNumberOfRequests,
);

export const selectCurrentTab = createSelector(
  selectOffer,
  (state: OverviewState) => state.currentTab,
);

export const selectFilters = createSelector(selectOffer, (state: OverviewState) =>
  state ? state.filters : undefined,
);
